import { UPDATE_DEALER } from './constants';

/**
 * UPDATE_DEALER action definition
 *
 * @param  {Object} dealer  dealer info from page preload
 * @return {Object}       UPDATE_DEALER action definition
 */
export function updateDealer(dealer) {
  return {
    type: UPDATE_DEALER,
    dealer,
  };
}
